module.exports = __webpack_public_path__ + "img/bai-user-ios.e23217a8.png";